import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.ParalaxRoot),
  () => import('./Paralax'),
  (Paralax) => {
    ComponentUtil.binder(Hooks.ParalaxRoot, Paralax);
  },
);
